import './bootstrap';
import './components/file-upload';
import './chat';

import Alpine from 'alpinejs';

// Chat Notification Store for Alpine
Alpine.store('chatNotificationStore', {
    totalUnreadCount: 0,
    ordersWithUnreadMessages: [],
    isLoading: true,
    userId: null,

    init() {
        this.userId = document.querySelector('meta[name="user-id"]')?.content;
        if (this.userId) {
            this.fetchSummary();
            this.listenForNotifications();
        } else {
            this.isLoading = false;
        }
    },

    fetchSummary() {
        this.isLoading = true;
        axios.get('/api/notifications/chat-summary')
            .then(response => {
                this.totalUnreadCount = response.data.totalUnreadCount;
                this.ordersWithUnreadMessages = response.data.ordersWithUnreadMessages;
            })
            .catch(error => {
                console.error('Error fetching chat notification summary:', error);
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    listenForNotifications() {
        if (window.Echo && this.userId) {
            window.Echo.private(`App.Models.User.${this.userId}`)
                .listen('.chat.notification', (event) => { // Note the leading dot for exact match with broadcastAs
                    console.log('ChatNotificationEvent received:', event);
                    this.totalUnreadCount = event.totalUnreadCount;
                    this.ordersWithUnreadMessages = event.ordersWithUnreadMessages;
                });
            console.log(`Listening for chat notifications on App.Models.User.${this.userId}`);
        } else {
            console.warn('Echo not available or user ID not found for chat notification listening.');
        }
    }
});

window.Alpine = Alpine;
Alpine.start();

// Handle CSRF token expiration gracefully
document.addEventListener('DOMContentLoaded', function() {
    // Intercept form submissions to handle CSRF errors
    document.addEventListener('submit', function(e) {
        const form = e.target;
        if (form.tagName === 'FORM') {
            const token = form.querySelector('input[name="_token"]');
            if (token) {
                // Update token before submission
                const metaToken = document.querySelector('meta[name="csrf-token"]');
                if (metaToken) {
                    token.value = metaToken.getAttribute('content');
                }
            }
        }
    });

    // Handle AJAX CSRF errors globally
    window.addEventListener('unhandledrejection', function(event) {
        if (event.reason && event.reason.status === 419) {
            alert('Your session has expired. The page will be refreshed.');
            window.location.reload();
        }
    });

    // Add visual indicator when session is about to expire
    let sessionWarningShown = false;

    setTimeout(function() {
        if (!sessionWarningShown) {
            sessionWarningShown = true;
            if (confirm('Your session will expire soon. Would you like to refresh it?')) {
                fetch('/csrf-token')
                    .then(response => response.json())
                    .then(data => {
                        document.querySelectorAll('input[name="_token"]').forEach(input => {
                            input.value = data.csrf_token;
                        });
                        const metaTag = document.querySelector('meta[name="csrf-token"]');
                        if (metaTag) {
                            metaTag.setAttribute('content', data.csrf_token);
                        }
                        sessionWarningShown = false;
                    });
            }
        }
    }, 715 * 60 * 1000); // Show warning 5 minutes before expiration (if session is 720 min)
});
